import api from '../services/api';
import { getErrorMessage } from './errorMessage';

export interface ChiaveDocumento {
  tipork: string;
  anno: number;
  serie: string;
  numdoc: number;
}

/** Scarica il PDF di un Documento. Il backend controlla che sia del Cliente e
 * rende un URL presigned del bucket, valido 5 minuti, che lo scarica
 * (`Content-Disposition: attachment`, nome `B_2025_03727.pdf`): si chiede
 * al clic e si apre subito, così il link non resta in pagina. */
export async function scaricaPdfDocumento(key: ChiaveDocumento): Promise<void> {
  const { data } = await api.get<{ url: string }>(
    `/api/clienti/me/documenti/${key.tipork}/${key.anno}/${key.numdoc}/pdf`,
    { params: { serie: key.serie } },
  );
  const a = document.createElement('a');
  a.href = data.url;
  a.rel = 'noopener';
  a.click();
}

/** Messaggio per un download PDF fallito: il `detail` del backend, che
 * distingue "non ancora disponibile" (404), "non distinguibile" (409) e
 * "archivio non raggiungibile" (503). */
export function pdfErrorMessage(e: unknown): string {
  return getErrorMessage(e, 'Errore nel recupero del PDF.');
}
